export default __webpack_public_path__ + "static/media/button-replay-2.6c69c90a.png";